import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, Users, Key, Network, BarChart2 } from '../../icons';
import { SidebarLayout } from '../SidebarLayout';
import { RoleSwitcherTR } from '../../tr/RoleSwitcherTR';
import { useAuth } from '../../../contexts/AuthContext';
import { isUserPartner } from '../../../lib/auth';
import { LoadingSpinner } from '../../LoadingSpinner';
import type { SidebarItem } from '../Sidebar';

const partnerItems: SidebarItem[] = [
  { label: 'Kontrol Paneli', path: '/tr/partner', icon: Brain },
  { label: 'Koclar', path: '/tr/partner/coaches', icon: Users },
  { label: 'Takimlar', path: '/tr/partner/teams', icon: Network },
  { label: 'Degerlendirme Kodlari', path: '/tr/partner/codes', icon: Key },
  { label: 'Analitik', path: '/tr/partner/analytics', icon: BarChart2 },
];

export function PartnerLayoutTR() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();
  const [authorized, setAuthorized] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate('/tr/login');
      return;
    }

    isUserPartner(user.id).then((isPartner) => {
      if (!isPartner) {
        navigate('/tr');
        return;
      }
      setAuthorized(true);
      setChecking(false);
    });
  }, [user, authLoading, navigate]);

  if (authLoading || checking || !authorized) {
    return <LoadingSpinner message="Yukleniyor..." />;
  }

  return (
    <SidebarLayout
      items={partnerItems}
      title="Partner"
      subtitle="Koclari ve takimlari yonetin"
      headerSlot={<RoleSwitcherTR currentRole="partner" />}
    />
  );
}
